/* global swal, _, angular*/
import './style.less';
import { keyBy, clone } from 'lodash';

export default function ($log, $stateParams, Swal, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;

  vm.routeParams = $stateParams;

  vm.pagination = {
    pageSize: 10,
    pageSizes: [10, 25, 50, 100]
  };

  vm.selectAll = select => {
    vm.registrants.forEach(user => {
      user.selected = select;
    });
    vm.updateSelected();
  };

  vm.pollNumbers = () => {
    const length = vm.event.webex.totalPolls || vm.event.webinar.totalPolls || vm.event.zoom.totalPolls || 0;
    return Array.from({ length }, (v, k) => k + 1).reverse();
  };

  vm.getCnfpolls = () => vm.event.polls.reduce((acc, poll) => (acc += poll.length), 0);

  vm.updateSelected = () => (vm.selected = vm.registrants.filter(user => user.selected).length);

  vm.display = (registrant, prop) => {
    switch (prop) {
      case 'hours':
        registrant.displayPolls = false;
        registrant.displayDuration = false;

        ApiClass.usersIdGet(
          { id: registrant.profile_uid },
          {},
          {
            queryParams: {
              'include:withchildren': true
            }
          },
          true
        )
          .then(({ data: { item: profile } }) => {
            registrant.profile = profile;
            registrant.displayHours = !registrant.displayHours;
          })
          .catch(error => {
            registrant.displayHours = !registrant.displayHours;
          });

        break;
      case 'blended':
      case 'polls':
      case 'duration':
        registrant.displayExternals = !registrant.displayExternals;
        break;
    }
  };

  vm.filter = () => {
    let registrants;

    switch (vm.evalFilter) {
      case 'complete':
        registrants = clone(vm.locationRegistrants).filter(({ profile_uid }) => vm.reviewsObj[profile_uid]);
        break;
      case 'incomplete':
        registrants = clone(vm.locationRegistrants).filter(({ profile_uid }) => !vm.reviewsObj[profile_uid]);
        break;
      default:
        registrants = clone(vm.locationRegistrants);
        break;
    }

    if (vm.pollFilter !== '')
      registrants = registrants.filter(({ answeredPolls }) => (answeredPolls || 0) === vm.pollFilter);

    vm.registrants = registrants;
  };

  vm.submit = () => {
    const selectedRegistrants = vm.registrants.filter(({ selected }) => selected);
    if (!selectedRegistrants.length) return Swal.alert('Hold Up!', 'No registrants have been selected', 'info');
    vm.submitBtn = true;

    vm.action({ certs: selectedRegistrants, suppress: vm.suppress })
      .then(() => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
      })
      .catch(error => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
        throw error;
      });
  };

  vm.sendEvals = () => {
    vm.submitBtn = true;
    const profile_uids = vm.registrants.filter(({ selected }) => selected).map(({ profile_uid }) => profile_uid);

    checkDate()
      .then(
        () => ApiClass.eventsIdTypePatch(
          { id: vm.event.event_id, type: 'attendees' },
          { profile_uids, sendEval: true },
          { queryParams: { manage: true } }
        )
      )
      .then(() => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
        Swal.toast('Evaluations sent!');
      })
      .catch(error => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
        throw error;
      });
  };

  function checkDate() {
    if (new Date(vm.event.delivery_end_date).getTime() > new Date().getTime()) {
      return Swal.confirm(
        'Send Evaluations',
        'This event has not ended. Do you still want to send evaluations?',
        'info'
      );
    }
    return Promise.resolve();
  }

  vm.sendPostwork = () => {
    vm.submitBtn = true;
    const profile_uids = vm.registrants.filter(({ selected }) => selected).map(({ profile_uid }) => profile_uid);
    ApiClass.eventsIdTypePatch(
      { id: vm.event.event_id, type: 'attendees' },
      { profile_uids, sendPostwork: true },
      { queryParams: { manage: true } }
    )
      .then(() => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
        Swal.toast('Postwork sent!');
      })
      .catch(error => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
        throw error;
      });
  };

  vm.syncWithEvent = () => {
    const selectedRegistrants = vm.registrants.filter(({ selected }) => selected);
    if (!selectedRegistrants.length) return Swal.alert('Hold Up!', 'No registrants have been selected', 'info');

    vm.registrants.forEach(registrant => {
      if (registrant.selected) {
        registrant.displayHours = false;
        registrant.hours = angular.copy(vm.event.hours || []);
        registrant.hours_basic = angular.copy(vm.event.hours_basic || []);
      }
    });

    Swal.html(
      'Registrants Updated!',
      `<p>The credits for the selected registrants have been updated with the current credit values.</p>
      <p>Attendees who require adjustment will need to be updated prior to submitting and re-issuing certificates.</p>`,
      'info'
    );
  };

  function activate() {
    $log.debug('Event Manager Basic Issue Component Activated');
    vm.selected = 0;

    try {
      if (!vm.event) throw new Error('No Event');
      if (!vm.action) throw new Error('No Action');
      vm.reviewsObj = keyBy(vm.event.reviews, 'profile_uid');
      vm.locationRegistrants = clone(vm.registrants);
      vm.loaded = true;
    } catch (error) {
      vm.loaded = true;
      vm.error = {
        status: true,
        refresh: activate
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/issueCertificates/controller.js